export default "__VITE_ASSET__D_lqzWO2__"